export class ConfigurationCategory {
  Id: number;
  Name: string;
  Description: string;
  DisplayOrder: number
}